export default __webpack_public_path__ + "a26d850375123885c2ccdeb2e8d7d4f5.png";